(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["digimaps-contact"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    root.querySelectorAll('.dg-contact-form').forEach((form) => {
      const select = form.querySelector('[data-dg-service]');
      const note = form.querySelector('[data-dg-starting-budget]');
      if (!select || !note || select.dataset.budgetNoteReady) return;
      select.dataset.budgetNoteReady = 'true';
      const update = () => {
        note.hidden = select.selectedOptions[0]?.dataset.startingBudget !== 'true';
      };
      select.addEventListener('change', update);
      form.addEventListener('reset', () => requestAnimationFrame(update));
      window.addEventListener('pageshow', update);
      update();
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["digimaps-ongoing-shopify-team"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (!window.DmcOngoingTeam) {
      const instances = new Map();

      const init = (root) => {
        if (!root || instances.has(root) || root.dataset.mobileSlider !== 'true') return;

        const track = root.querySelector('[data-dmc-track]');
        const slides = Array.from(root.querySelectorAll('[data-dmc-slide]'));
        const previous = root.querySelector('[data-dmc-prev]');
        const next = root.querySelector('[data-dmc-next]');
        const dots = Array.from(root.querySelectorAll('[data-dmc-dot]'));
        const mobileQuery = window.matchMedia('(max-width: 749px)');
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        if (!track || slides.length < 2) return;

        let activeIndex = 0;
        let frame = null;
        let timer = null;

        const getLeft = (slide) => {
          const padding = parseFloat(window.getComputedStyle(track).paddingInlineStart) || 0;
          return Math.max(0, slide.offsetLeft - padding);
        };

        const nearestIndex = () => {
          const left = track.scrollLeft;
          let nearest = 0;
          let distance = Infinity;

          slides.forEach((slide, index) => {
            const currentDistance = Math.abs(getLeft(slide) - left);
            if (currentDistance < distance) {
              distance = currentDistance;
              nearest = index;
            }
          });

          return nearest;
        };

        const updateControls = (index) => {
          activeIndex = Math.max(0, Math.min(index, slides.length - 1));

          if (previous) previous.disabled = activeIndex === 0;
          if (next) next.disabled = activeIndex === slides.length - 1;

          dots.forEach((dot, dotIndex) => {
            const isActive = dotIndex === activeIndex;
            dot.classList.toggle('is-active', isActive);
            if (isActive) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
        };

        const goTo = (index, behavior = 'smooth') => {
          const safeIndex = Math.max(0, Math.min(index, slides.length - 1));
          track.scrollTo({
            left: getLeft(slides[safeIndex]),
            behavior: reducedMotion.matches ? 'auto' : behavior
          });
          updateControls(safeIndex);
        };

        const stopAutoplay = () => {
          if (timer) window.clearInterval(timer);
          timer = null;
        };

        const startAutoplay = () => {
          stopAutoplay();
          if (
            root.dataset.autoplay !== 'true' ||
            !mobileQuery.matches ||
            reducedMotion.matches ||
            document.hidden
          ) return;

          const interval = Number(root.dataset.autoplaySpeed) || 5000;
          timer = window.setInterval(() => {
            const target = activeIndex >= slides.length - 1 ? 0 : activeIndex + 1;
            goTo(target);
          }, interval);
        };

        const onScroll = () => {
          if (frame) window.cancelAnimationFrame(frame);
          frame = window.requestAnimationFrame(() => updateControls(nearestIndex()));
        };

        const onResize = () => {
          if (mobileQuery.matches) goTo(activeIndex, 'auto');
          startAutoplay();
        };

        const onVisibility = () => startAutoplay();
        const onInteraction = () => stopAutoplay();
        const onInteractionEnd = () => startAutoplay();

        previous?.addEventListener('click', () => goTo(activeIndex - 1));
        next?.addEventListener('click', () => goTo(activeIndex + 1));
        dots.forEach((dot, index) => dot.addEventListener('click', () => goTo(index)));
        track.addEventListener('scroll', onScroll, { passive: true });
        track.addEventListener('pointerdown', onInteraction, { passive: true });
        track.addEventListener('pointerup', onInteractionEnd, { passive: true });
        track.addEventListener('focusin', onInteraction);
        track.addEventListener('focusout', onInteractionEnd);
        document.addEventListener('visibilitychange', onVisibility);
        mobileQuery.addEventListener?.('change', onResize);

        updateControls(0);
        startAutoplay();

        instances.set(root, {
          goTo,
          destroy: () => {
            stopAutoplay();
            if (frame) window.cancelAnimationFrame(frame);
            track.removeEventListener('scroll', onScroll);
            track.removeEventListener('pointerdown', onInteraction);
            track.removeEventListener('pointerup', onInteractionEnd);
            track.removeEventListener('focusin', onInteraction);
            track.removeEventListener('focusout', onInteractionEnd);
            document.removeEventListener('visibilitychange', onVisibility);
            mobileQuery.removeEventListener?.('change', onResize);
            instances.delete(root);
          }
        });
      };

      const initWithin = (container = document) => {
        if (container.matches?.('[data-dmc-ongoing]')) init(container);
        container.querySelectorAll?.('[data-dmc-ongoing]').forEach(init);
      };

      document.addEventListener('shopify:section:load', (event) => initWithin(event.target));
      document.addEventListener('shopify:section:unload', (event) => {
        const root = event.target.matches?.('[data-dmc-ongoing]')
          ? event.target
          : event.target.querySelector?.('[data-dmc-ongoing]');
        instances.get(root)?.destroy();
      });
      document.addEventListener('shopify:block:select', (event) => {
        const slide = document.getElementById(`DmcOngoingBlock-${event.detail.blockId}`);
        if (!slide) return;
        const root = slide.closest('[data-dmc-ongoing]');
        const slides = Array.from(root.querySelectorAll('[data-dmc-slide]'));
        instances.get(root)?.goTo(slides.indexOf(slide));
      });

      window.DmcOngoingTeam = { initWithin };
    }

    window.DmcOngoingTeam.initWithin(document);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerWrapper = document.querySelector('.header-wrapper');
      this.headerInner = document.querySelector('.header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

      if (this.headerIsAlwaysSticky) this.reveal;
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      if (this.header) {
        observer.observe(this.header);
      }
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
        this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-always-sticky');
      }

      if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
        this.header.classList.remove('shopify-section-header-sticky');
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      if (this.disclosures) {
        this.disclosures.forEach((disclosure) => {
          disclosure.close();
        });
      }
      this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
      if (this.disclosureLists) {
        this.disclosureLists.forEach((disclosureList) => {
          disclosureList.setAttribute('hidden', true);
        });
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
